// src/useQuery.ts
import { QueryObserver } from "@tanstack/query-core";
import { useBaseQuery } from "./useBaseQuery.js";
function useQuery(options, queryClient) {
  return useBaseQuery(QueryObserver, options, queryClient);
}
export {
  useQuery
};
//# sourceMappingURL=useQuery.js.map